import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const adminUser = localStorage.getItem("adminUser") || "Hexaplay_Admin";

  useEffect(() => {
    if (localStorage.getItem("adminAuth") !== "true") {
      navigate("/admin/login", { replace: true });
    }
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("adminAuth");
      localStorage.removeItem("adminUser");
      navigate("/admin/login", { replace: true });
    }
  };

  const tools = [
    {
      icon: "📄",
      title: "Auditor Invoice Generation",
      description: "Generate professional invoices for auditing and records",
      path: "/InvoiceMaker",
      color: "#8b5cf6",
      btnColor: "#7c3aed"
    },
    {
      icon: "🗄️",
      title: "Customer Database",
      description: "All customer inquiries, bookings, events & gaming sessions in one place",
      path: "/superadmin/customer-db",
      color: "#ec4899",
      btnColor: "#db2777"
    },
    {
      icon: "📋",
      title: "Staff Management List",
      description: "View all orders before they are frozen",
      path: "/StaffManagement",
      color: "#10b981",
      btnColor: "#059669"
    },
    {
      icon: "🏠",
      title: "Room Card Control",
      description: "Manage room cards, availability, and configurations",
      path: "/superadmin/roomcard-control",
      color: "#f59e0b",
      btnColor: "#d97706"
    },
    {
      icon: "🔄",
      title: "Transfer Contact",
      description: "Transfer and manage customer contact records",
      path: "/TransferContact",
      color: "#06b6d4",
      btnColor: "#0891b2"
    }
  ];

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="header-content">
          <div className="header-left">
            <div className="admin-logo">🛡️</div>
            <div>
              <h1>Admin Panel</h1>
              <p>HexaPlay Control Center</p>
            </div>
          </div>
          <div className="header-right">
            <div className="admin-pill">
              <span className="avatar">👨‍💼</span>
              <span>{adminUser}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </header>

      <main className="admin-main">
        <div className="welcome-section">
          <h2>👋 Welcome back, <span className="highlight">{adminUser}</span></h2>
          <p>Here's what's happening with your business today.</p>
        </div>

        <div className="admin-tools">
          <h3 className="section-title">⚡ Admin Tools</h3>
          <div className="tools-grid">
            {tools.map((tool, index) => (
              <div
                key={index}
                className="tool-card"
                onClick={() => navigate(tool.path)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="tool-icon" style={{ background: `${tool.color}15`, color: tool.color }}>
                  {tool.icon}
                </div>
                <h4>{tool.title}</h4>
                <p>{tool.description}</p>
                <button 
                  className="tool-button"
                  style={{ background: tool.btnColor }}
                  onClick={(e) => { e.stopPropagation(); navigate(tool.path); }}
                >
                  Open Tool →
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;